import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { registeredUserPageQueryOptions } from "~/app/api/pageData/registeredUserPageQuery";
import type { RegisteredUserPageInitialData } from "~/app/api/pageData/registeredUserPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { RegisterForFreePage } from "~/pages/RegisterForFreePage/RegisterForFreePage";

function RegisteredUserRoute() {
  const result = useLoaderData({
    from: "/registered/user",
  }) as PageInitialData<RegisteredUserPageInitialData>;
  const shellProps = useStorefrontShellProps();
  const becomeBusinessUser = result.data?.becomeBusinessUser ?? false;

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      <RegisterForFreePage showCustomerRegistration={becomeBusinessUser} />
    </StorefrontShellFrame>
  );
}

export async function loadRegisteredUserPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(registeredUserPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const registeredUserRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/registered/user",
  loader: async ({ context }) => loadRegisteredUserPageData(context),
  component: RegisteredUserRoute,
});
